import React from 'react'
import PlatformLink from '../PlatformLink'
import normalizeHostname from 'utils/normalizeHostname'
import NavLinkWithDropdown from './NavLinkWithDropdown'

const buildLinkHref = (servers, platform) =>
  servers.length === 0
    ? platform.homeUrl
    : normalizeHostname(servers[0].hostname, platform.id)

const AuthenticatedNavLink = ({ servers, platform, children, ...rest }) => {
  if (servers.length < 2) {
    return (
      <PlatformLink href={buildLinkHref(servers, platform)}>
        {children}
      </PlatformLink>
    )
  }
  return (
    <NavLinkWithDropdown
      children={children}
      platform={platform}
      servers={servers}
      {...rest}
    />
  )
}

export default AuthenticatedNavLink



// WEBPACK FOOTER //
// ./src/routes/home/components/MultiServerPlatformNavLink/AuthenticatedNavLink.js